import { Component } from '@angular/core';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsMessageComponent
} from "@wms/components";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {DialogService, UserService} from "@wms/services";
import {SessionTimeoutService} from "@wms/app/services/session-timeout/session-timeout.service";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent
  ],
  selector: 'wms-session-timeout',
  templateUrl: './wms-session-timeout.component.html',
  styleUrls: ['./wms-session-timeout.component.less']
})
export class WmsSessionTimeoutComponent extends BaseComponent {

  userData = {email: '', password: ''};
  isLoginInProgress: boolean = false;
  msgData: any = {type: '', show: false, caption: ''};

  constructor(private userService: UserService,
              private sessionTimeoutService: SessionTimeoutService,
              private dialogService: DialogService) {
    super();
    this.initLoginForm();
  }

  /**
   * gets the logged-in user email and populates the respective email
   * the end user just is just required to provide password and login
   */
  initLoginForm() {
    const userDetails = this.userService.get() || {};
    this.userData.email = userDetails.emailAddress || userDetails.email || '';
  }

  /**
   * sets the message and message type to show on the dialog
   * @param msg
   * @param type
   */
  showMsg(msg: string, type: string) {
    this.msgData = {show: true, caption: msg, type: type};
  }

  /**
   * validates credentials and performs login action
   * post login, completes the session timeout observable
   */
  login() {
    const email = this.userData.email,
      password = this.userData.password;

    // validation
    if (!email) {
      this.showMsg(this.locale['MESSAGE_WARN_LOGIN_ID_EMPTY'], 'error');
      return;
    } else if (!password) {
      this.showMsg(this.locale['MESSAGE_WARN_PASSWORD_EMPTY'], 'error');
      return;
    }

    // loading message
    this.showMsg(this.locale['MESSAGE_LOGIN_PROGRESS'], 'loading');
    this.isLoginInProgress = true;

    // call login api
    this.userService.login({email, password})
      .then(() => {
        this.isLoginInProgress = false;
        this.sessionTimeoutService.markLoginSuccess();
        this.dialogService.close('sessionTimeoutDialog');
      })
      .catch(()=> {
        this.isLoginInProgress = false
        this.showMsg('Error, please try again', 'error');
      });
  }
}
